import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {setCurrentUser} from '../features/users/usersSlice'
import {setOnboarding} from './onboarding'
import {setBranding} from './branding'
import {setAcceptedCurrencyId,setAcceptedCurrencies,setGymResourceSettings,setAppSettings} from '../features/settings/settingsSlice'
import {envAwarePost} from '../util/util'
import {setUserClientFeatures} from './layout'
import {setHasCRM} from '../features/Growth/slice'

export const initApp = createAsyncThunk( 
	'init', 
	async (payload,{dispatch})=>{
		const {success,message,data} = await envAwarePost(
			'api/init/api/',{action:'getInitData',platform:'web'}
		) 
		if(success === '1'){
			const {
				custom_app_data,
				onboarding,
				trainer_data,
				currency,
				accepted_currencies,
				user_client_features,
				user,
				app_settings,
				has_crm
			} = data
			dispatch(setHasCRM(Boolean(has_crm)))
			dispatch(setAppSettings(app_settings))
			dispatch(setBranding(custom_app_data))
			dispatch(setCurrentUser(user))
			dispatch(setOnboarding(onboarding))
			dispatch(setAcceptedCurrencyId(currency?.id))
			dispatch(setAcceptedCurrencies(accepted_currencies))
			dispatch(setUserClientFeatures(user_client_features))
			//only gym related accounts will have the gym resource
			//settings
			if(data.gym_resource_settings){
				dispatch(setGymResourceSettings(data.gym_resource_settings))	
			}
		}else{
			alert(message)
		}
	}
)

export const get_user_id_number = createAsyncThunk(
    "get_user_id_number",
    async(payload) => (envAwarePost("publicAccess.php", {action:"get_user_id_number"}))
)

export const getMobileStatus = createAsyncThunk(
    "getMobileStatus",
    async(payload) => (envAwarePost("api/init/api", {action:"getMobileStatus"}))
)




const initSlice = createSlice({
	name: 'init',
	initialState:{
		status:'idle',
		statusUserId : 'pending'
	},
	reducers: {},
	extraReducers:{
		[initApp.pending] : (state)=>{
			state.status = 'pending'
		},
		[initApp.fulfilled] : (state)=>{
			state.status = 'idle'
		},
		[get_user_id_number.fulfilled]:(state) =>{
			state.statusUserId = "idle"
		},
		[get_user_id_number.rejected]:(state) =>{
			state.statusUserId = "idle"
		}
	}
})


export default initSlice.reducer